var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.browser == true)?_c('p',{staticClass:"dowimgpsps6_9"},[_vm._v(" 如不跳转，请点击右上角，选择浏览器打开 ")]):_c('p',{staticClass:"dowimgpsps6_9"},[_vm._v("请稍后")])])}
var staticRenderFns = []

export { render, staticRenderFns }